module.exports = __webpack_public_path__ + "img/75661.eac16ffe.svg";